const AWS = {
    desarrollo: {
        // TODO check those values are valid
        "aws_project_region": "us-east-1",
        "aws_cognito_region": "us-east-1",
        "aws_user_pools_id": "us-east-1_I5NFKx2WH",
        "aws_user_pools_web_client_id": "56f42g0r5iv4eiau6n712cjukv",
        "oauth": {
            "domain": "back2work-dev.auth.us-east-1.amazoncognito.com",
            "scope": [
                "phone",
                "email",
                "openid",
                "profile",
                "aws.cognito.signin.user.admin"
            ],
            "redirectSignIn": "http://b2w-dashboards.wokko.io/login",
            "redirectSignOut": "http://b2w-dashboards.wokko.io/login",
            "responseType": "code"
        }
    },
    demo: {
        "aws_project_region": "us-east-1",
        "aws_cognito_region": "us-east-1",
        "aws_user_pools_id": "us-east-1_dR9F90YVC",
        "aws_user_pools_web_client_id": "hf26huf29civg29f3irm0hiqc",
        "oauth": {
            "domain": "https://back2work-demo.auth.us-east-1.amazoncognito.com",
            "scope": [
                "phone",
                "email",
                "openid",
                "profile",
                "aws.cognito.signin.user.admin"
            ],
            "redirectSignIn": "http://b2w-dashboards.wokko.io/login",
            "redirectSignOut": "http://b2w-dashboards.wokko.io/login",
            "responseType": "code"
        }
    },
    qa: {
        "aws_project_region": "us-east-1",
        "aws_cognito_region": "us-east-1",
        "aws_user_pools_id": "us-east-1_6QoOIFFHE",
        "aws_user_pools_web_client_id": "6k8kcrqq88ec2da3v9001t9gpo",
        "oauth": {
            "domain": "https://back2work-qa.auth.us-east-1.amazoncognito.com",
            "scope": [
                "phone",
                "email",
                "openid",
                "profile",
                "aws.cognito.signin.user.admin"
            ],
            "redirectSignIn": "http://b2w-dashboards.wokko.io/login",
            "redirectSignOut": "http://b2w-dashboards.wokko.io/login",
            "responseType": "code"
        }
    },
    prod: {
        "aws_project_region": "us-east-1",
        "aws_cognito_region": "us-east-1",
        "aws_user_pools_id": "us-east-1_I5NFKx2WH",
        "aws_user_pools_web_client_id": "56f42g0r5iv4eiau6n712cjukv",
        "oauth": {
            "domain": "https://bkd-anahuac.back2w.com/api-docs/",
            "scope": [
                "phone",
                "email",
                "openid",
                "profile",
                "aws.cognito.signin.user.admin"
            ],
            "redirectSignIn": "http://b2w-dashboards.wokko.io/login",
            "redirectSignOut": "http://b2w-dashboards.wokko.io/login",
            "responseType": "code"
        }
    }
};


export default AWS;